























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import StatisticsOverview from "./StatisticsOverview.vue";
import StatisticsRental from "./StatisticsRental.vue";

import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Statistics",
  components: {
    MainTabbar,
    StatisticsOverview,
    StatisticsRental,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    userActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
      currentMainTabbarTab: "",
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  watch: {
    /* mainTabbarItems() {
      this.initTab();
    }, */
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Geburtstage",
          linkedComponent: "StatisticsOverview",
          permissionRank: 2,
          userPermission: null,
          isDisabled:
            !vue.checkModuleIsActivated(vue.userActiveModules, "Birthdays") &&
            !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
          isDisplayed:
            vue.checkModuleIsActivated(vue.userActiveModules, "Birthdays") &&
            vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleBirthdays),
        },
        {
          title: "Verleih",
          linkedComponent: "StatisticsRental",
          permissionRank: 2,
          userPermission: null,
          isDisabled:
            !vue.checkModuleIsActivated(vue.userActiveModules, "Rental") &&
            !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleRental),
          isDisplayed:
            vue.checkModuleIsActivated(vue.userActiveModules, "Rental") &&
            vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleRental),
        },
      ] as ModulesJson[];
    },
  },
});
